export default "__VITE_ASSET__CgFMatEm__"